import './App.css';
import { Routes,Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';

import { Login } from './actions/actions'
import { cookies_string } from './config.js'
import { useEffect, useState, useRef } from 'react';
//
import Nav from './components/Nav.js'
import RightNavBar from './components/RightNavBar.js'
import PageNotFound from './screens/PageNotFound'
import Home from './screens/Home.js';
import Concept from './screens/Concept.js';
import Rooms from './screens/Rooms.js'
import Faq from './screens/Faq.js'
import News from './screens/News.js'
import News2 from './screens/News2.js';
import NewDetail from './screens/NewDetail.js';
import NewsDetail2 from './screens/NewDetail2.js'
import Facility from './screens/Facility.js';
import Privacy from './screens/privacy.js'
import Reservation from './screens/Reservation.js';
import Message from './screens/message.js';
//
import RightSizeLang from './components/RightSideLang.js';
import RightSizeBook from './components/RightSideBook.js';
function App(props) {
  const [cookies, setCookie, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
  const scrollRef = useRef(null);
  const [leftNav, setLeftNav] = useState(false)
  const location = useLocation()

  const handleSetLeftNav = (bool) => setLeftNav(bool)

  const [scrollY, setScrollY] = useState(0);
  const handleScroll=(e)=>{
    setScrollY(e.target.scrollTop)
  }
  useEffect(() => {
    scrollRef.current.scrollTop = 0
  },[location.pathname])
  return (
    <div className="relative root flex flex-col w-full h-full min-w-[100vw] min-h-[100vh] overflow-y-hidden" style={{overflow:'hidden'}}>
      <Nav scrollRef={scrollRef} setRightNav={leftNav} handleSetRightNav={handleSetLeftNav}/>
      <RightNavBar rightNav={leftNav} setRightNav={setLeftNav} handleSetRightNav={handleSetLeftNav}/>
      <div onScroll={handleScroll} ref={scrollRef} className='w-[100%] flex flex-col overflow-y-auto overflow-x-hidden temp-noscroll'>
        <Routes>
            <Route path="/" element={<Home scrollRef={scrollRef} scrollY={scrollY}/>}/>
            <Route path="/index.html" element={<Home scrollY={scrollY}/>}/>
            <Route path="/concept" element={<Concept />}/>
            <Route path="/rooms" element={<Rooms/>}/>
            <Route path="/facility" element={<Facility/>}/>
            <Route path="/news" element={<News2/>}/>
            <Route path="/news/:id" element={<NewsDetail2/>}/>
            <Route path="/faq" element={<Faq/>}/>
            <Route path="/privacy-policy" element={<Privacy/>}/>
            <Route path="/reservation"  element={<Reservation scrollY={scrollY} scrollRef={scrollRef}/>}/>
            <Route path="/messages"  element={<Message />}/>
            <Route path="*" element={<PageNotFound />}/>
            {/* <Route path="/news" element={<News/>}/>
            <Route path="/news/:id" element={<NewDetail/>}/> */}
        </Routes>
      </div>
      <RightSizeLang />
      <RightSizeBook />
    </div>
  );


}

export default connect((store)=>{
  return{
    token:store.tokenReducer,
    control:store.controlReducer,
  }
})(App)